import { render, staticRenderFns } from "./phoria.score.vue?vue&type=template&id=55c9cdcb"
import script from "./phoria.score.vue?vue&type=script&lang=js"
export * from "./phoria.score.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports